module.exports = __webpack_public_path__ + "img/school-list.91c65f49.svg";